/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDiscountCalculation } from './OrderDiscountCalculation';
import {
    OrderDiscountCalculationFromJSON,
    OrderDiscountCalculationFromJSONTyped,
    OrderDiscountCalculationToJSON,
    OrderDiscountCalculationToJSONTyped,
} from './OrderDiscountCalculation';

/**
 * 
 * @export
 * @interface OrderDiscountSearchEssential
 */
export interface OrderDiscountSearchEssential {
    /**
     * 
     * @type {string}
     * @memberof OrderDiscountSearchEssential
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDiscountSearchEssential
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDiscountSearchEssential
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscountSearchEssential
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscountSearchEssential
     */
    priority: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscountSearchEssential
     */
    isDisplayedGoFrens?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscountSearchEssential
     */
    expiresAt?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDiscountSearchEssential
     */
    nftGroupings?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDiscountSearchEssential
     */
    businesses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrderDiscountSearchEssential
     */
    image?: string;
    /**
     * 
     * @type {OrderDiscountCalculation}
     * @memberof OrderDiscountSearchEssential
     */
    calculation: OrderDiscountCalculation;
}



/**
 * Check if a given object implements the OrderDiscountSearchEssential interface.
 */
export function instanceOfOrderDiscountSearchEssential(value: object): value is OrderDiscountSearchEssential {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('calculation' in value) || value['calculation'] === undefined) return false;
    return true;
}

export function OrderDiscountSearchEssentialFromJSON(json: any): OrderDiscountSearchEssential {
    return OrderDiscountSearchEssentialFromJSONTyped(json, false);
}

export function OrderDiscountSearchEssentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDiscountSearchEssential {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'],
        'priority': json['priority'],
        'isDisplayedGoFrens': json['isDisplayedGoFrens'] == null ? undefined : json['isDisplayedGoFrens'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'nftGroupings': json['nftGroupings'] == null ? undefined : json['nftGroupings'],
        'businesses': json['businesses'] == null ? undefined : json['businesses'],
        'image': json['image'] == null ? undefined : json['image'],
        'calculation': OrderDiscountCalculationFromJSON(json['calculation']),
    };
}

export function OrderDiscountSearchEssentialToJSON(json: any): OrderDiscountSearchEssential {
    return OrderDiscountSearchEssentialToJSONTyped(json, false);
}

export function OrderDiscountSearchEssentialToJSONTyped(value?: OrderDiscountSearchEssential | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'description': value['description'],
        'amount': value['amount'],
        'priority': value['priority'],
        'isDisplayedGoFrens': value['isDisplayedGoFrens'],
        'expiresAt': value['expiresAt'],
        'nftGroupings': value['nftGroupings'],
        'businesses': value['businesses'],
        'image': value['image'],
        'calculation': OrderDiscountCalculationToJSON(value['calculation']),
    };
}

